/** @license ISC License (c) copyright 2016 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var hasAlg = require('./hasAlg')
var isAlt = require('./isAlt')

// isPlus : a -> Boolean
function isPlus(m) {
  return isAlt(m)
    && (hasAlg('zero', m) || hasAlg('zero', m.constructor))
}

module.exports = isPlus
